const buttonHover = '#3F5B74';
const darkOcean = '#496A86';
const lightSky = '#DEF3FA';
const pebbleStone = '#CFCFCF';

export const colors = {
  buttonDefault: darkOcean,
  buttonDisabled: pebbleStone,
  buttonHover: buttonHover,
  cardBackgroundHover: buttonHover,
  crederaRed: '#E55F4C',
  darkOcean: darkOcean,
  deepSmoke: '#525252',
  footerBackground: '#2D4153',
  gray1: '#757575',
  gray2: '#9B9B9B',
  gray3: pebbleStone, // pebbleGray
  gray5: '#F9F9F9',
  labelDefault: '#6B6B6B',
  lightSky: lightSky,
  linkDefault: darkOcean,
  linkHover: buttonHover, //gradient1
  linkHover2: '#4C99CC', //gradient2
  midnightBlack: '#3A3A3A',
  oceanBlue: darkOcean,
  pureWhite: '#FFFFFF', // backgroundDefault
  sandBeige: '#F8F5F2',
  secondaryBackground: lightSky,
  winterBlue: '#5CA2D1',
};

export const extendedColors = {
  crederaRed: {
    light: '#ED8978'
  },
  winterBlue: {
    lightest: '#D7ECF3'
  }
};
